import { ExcelIcon2 } from '@shared/custom-icons';
import TextButton from './TextButton';
import React from 'react';
import { useAppTFunction } from '@retail/app/i18n';

interface Props {
  onClick: () => void;
  loading: boolean;
  disabled?: boolean;
}

export const ExportToExcelButton: React.FC<Props> = (props) => {
  const t = useAppTFunction();

  return (
    <TextButton size="small" startIcon={<ExcelIcon2 />} sx={{ whiteSpace: 'nowrap' }} {...props}>
      {t('common.exportToExcel')}
    </TextButton>
  );
};
